<script setup>
import { onMounted, getCurrentInstance } from "vue";
import { RouterLink } from "vue-router";
import { useI18n } from "../i18n";
import { getCurrentShopConfig } from "../shopConfig";

const _shopConfig = getCurrentShopConfig();
const productViewPath = new URL(_shopConfig.pageBaseUrl).pathname;

const instance = getCurrentInstance();
const cropimage = instance.appContext.config.globalProperties.$cropimage;
let ctx = false;
let canvas = document.getElementById("canvas");
const props = defineProps({
  srcbild: { type: String },
  option: { type: Object },
  type: { type: Number },
});
const { t } = useI18n();

// function drawCircleWithGradient(ctx, x, y, r, g, b, radius, darker, lighter) {
//   const posX = x * radius * 2 + radius;
//   const posY = y * radius * 2 + radius;
//
//   const grd = ctx.createRadialGradient(posX, posY, 0, posX, posY, radius);
//   grd.addColorStop(0, `rgb(${r * lighter / 100}, ${g * lighter / 100}, ${b * lighter / 100})`);
//   grd.addColorStop(0.5, `rgb(${r}, ${g}, ${b})`);
//   grd.addColorStop(1, `rgb(${r * darker / 100}, ${g * darker / 100}, ${b * darker / 100})`);
//
//
//   ctx.fillStyle = grd;
//   ctx.beginPath();
//   ctx.arc(posX, posY, radius, 0, Math.PI * 2);
//   ctx.fill();
// }
function getDimensionsDataFromTitle(title) {
  // 2x20x35-2x20x45-1x20x55
  if (title.match(/2x(\d+)x(\d+)-2x(\d+)x(\d+)\D.*(\d\d)/)) {
    const split = 5;
    const single = parseInt(RegExp.$1);
    const step1 = parseInt(RegExp.$2);
    const step2 = parseInt(RegExp.$4);
    const short = parseInt(RegExp.$5);
    const long = split * single;
    const steps = [step1, step2, short, step2, step1];

    return {
      split,
      steps,
      short,
      long,
      format: "split5",
    };
  }

  // Hard-coded dimensions for US split5
  if (title === '39" x 22" / 100x55cm') {
    const split = 5;
    const single = 20;
    const step1 = 35;
    const step2 = 45;
    const short = 55;
    const long = split * single;
    const steps = [step1, step2, short, step2, step1];

    return {
      split,
      steps,
      short,
      long,
      format: "split5",
    };
  }

  // Hard-coded dimensions for US small split3
  if (title === '32" x 16" / 81x40cm') {
    const split = 3;
    const single = 27;
    const short = 40;
    const long = split * single;
    const steps = [single, single, single];

    return {
      split,
      steps,
      short,
      long,
      format: "split3",
    };
  }

  // Hard-coded dimensions for US large split3
  if (title === '44" x 22" / 111x55cm') {
    const split = 3;
    const single = 37;
    const short = 55;
    const long = split * single;
    const steps = [single, single, single];

    return {
      split,
      steps,
      short,
      long,
      format: "split3",
    };
  }

  if (title.match(/(\d+)x(\d+)x(\d+)\D*/)) {
    const split = 3;
    const single = parseInt(RegExp.$2);
    const short = parseInt(RegExp.$3);
    const long = split * single;
    const steps = [single, single, single];

    return {
      split,
      steps,
      short,
      long,
      format: "split3",
    };
  }

  if (title.match(/(\d+)x(\d+)\D*/)) {
    let short = parseInt(RegExp.$1);
    let long = parseInt(RegExp.$2);

    if (short > long) {
      const tmp = short;
      short = long;
      long = tmp;
    }

    return {
      short,
      long,
      format: short === long ? "square" : "rect",
    };
  }

  return false;
}

function drawStep5(orientation, dimensions) {
  // console.log('Male weiße Flächen');

  const w = canvas.width;
  const h = canvas.height;
  ctx = canvas.getContext("2d");
  ctx.lineWidth = 1;
  ctx.strokeStyle = "#c5c1bc";
  ctx.fillStyle = "#c5c1bc";

  const cut1 = (dimensions.short - dimensions.steps[0]) / dimensions.short;
  const cut2 = (dimensions.short - dimensions.steps[1]) / dimensions.short;

  if (orientation === "landscape") {
    const split = w / 5;
    splitLineDown(split, h);
    splitLineDown(2 * split, h);
    splitLineDown(3 * split, h);
    splitLineDown(4 * split, h);

    cutHeightOfWidthN(cut1, w, h, 0);
    cutHeightOfWidthN(cut2, w, h, 1);
    cutHeightOfWidthN(cut2, w, h, 3);
    cutHeightOfWidthN(cut1, w, h, 4);

    return;
  }

  if (orientation === "portrait") {
    const split = h / 5;
    splitLineRight(w, split);
    splitLineRight(w, 2 * split);
    splitLineRight(w, 3 * split);
    splitLineRight(w, 4 * split);

    cutWidthOfHeightN(cut1, w, h, 0);
    cutWidthOfHeightN(cut2, w, h, 1);
    cutWidthOfHeightN(cut2, w, h, 3);
    cutWidthOfHeightN(cut1, w, h, 4);
  }
}
function cutWidthOfHeightN(widthCut, w, h, i) {
  const rd = Math.round;
  ctx.fillRect(0, rd((h / 5) * i), rd((widthCut / 2) * w), rd(h / 5));
  ctx.fillRect(rd(w - (widthCut / 2) * w), rd((h / 5) * i), w, rd(h / 5));
}
function cutHeightOfWidthN(heightCut, w, h, i) {
  const rd = Math.round;
  ctx.fillRect(rd((w / 5) * i), 0, rd(w / 5) + 1, rd((heightCut / 2) * h));
  ctx.fillRect(
    rd((w / 5) * i),
    rd(h - (heightCut / 2) * h),
    rd(w / 5) + 1,
    rd((heightCut / 2) * h),
  );
}

function drawStep3(orientation) {
  const w = canvas.width;
  const h = canvas.height;
  ctx = canvas.getContext("2d");
  ctx.fillStyle = "#c5c1bc";
  // console.log('MALE LINIEN', orientation, w, h);

  if (orientation === "landscape") {
    splitLineDown(w / 3, h);
    splitLineDown((2 * w) / 3, h);
    return;
  }

  if (orientation === "portrait") {
    splitLineRight(w, h / 3);
    splitLineRight(w, (2 * h) / 3);
  }
}
function splitLineRight(x, y, width = 10) {
  ctx.fillRect(0, Math.round(y), x, width);
}

function splitLineDown(x, y, width = 10) {
  ctx.fillRect(Math.round(x), 0, width, y);
}

// function zurueckZurVorherigenKomponente() {
//   // Zurück zur vorherigen Komponente navigieren
//   instance.appContext.config.globalProperties.$router.back();
// }

onMounted(() => {
  const ration = props.option[_shopConfig.optionKeys.size].split("x");
  // let scaling = Math.round((80*150) / (ration[0]*ration[1].slice(0, -2)));
  //
  // scaling += 2;
  // if(scaling > 10) {
  //   scaling = 10
  // }
  //
  // if(scaling < 3) {
  //   scaling = 3
  // }

  const maxWidth = 800; // Maximal erlaubte Breite
  const maxHeight = 800; // Maximal erlaubte Höhe
  canvas = document.getElementById("canvas");
  ctx = canvas.getContext("2d");
  const image = new Image();
  image.src = cropimage.value;

  if (cropimage.value === undefined) {
    image.src = props.srcbild;
  }
  image.onload = function () {
    // if (image.width > maxWidth) {
    //   const scaleFactor = maxWidth / image.width;
    //   image.width = maxWidth;
    //   image.height *= scaleFactor;
    // }
    //
    // if (image.height > maxHeight) {
    //   const scaleFactor = maxHeight / image.height;
    //   image.height = maxHeight;
    //   image.width *= scaleFactor;
    // }

    if (image.width > maxWidth || image.height > maxHeight) {
      const scaleFactor = Math.min(
        maxWidth / image.width,
        maxHeight / image.height,
      );
      image.width *= scaleFactor;
      image.height *= scaleFactor;
    }

    canvas.width = image.width;
    canvas.height = image.height;
    ctx.drawImage(image, 0, 0, image.width, image.height);

    let lighter = 65;
    let darker = 170;

    let brickX = ration[0] * 4;
    let brickY = ration[1].slice(0, -2) * 4;
    let brickSizeX = canvas.width / brickX;
    let brickSizeY = canvas.height / brickY;
    let scaling = Math.ceil(brickSizeY);

    if (image.width > image.height) {
      scaling = Math.ceil(brickSizeX);
    }

    const scaleFactor = scaling; // Oder ein anderer gewünschter Wert
    const size = scaling; // Oder ein anderer gewünschter Wert
    // const scaleFactor = 8; // Oder ein anderer gewünschter Wert
    const steinform = props.option[_shopConfig.optionKeys.stoneShape];
    const dataWithAlpha = ctx.getImageData(
      0,
      0,
      image.width,
      image.height,
    ).data;

    for (let x = 0; x < image.width / scaleFactor; x++) {
      for (let y = 0; y < image.height / scaleFactor; y++) {
        const posX = x * scaleFactor;
        const posY = y * scaleFactor;

        const pos = (posY * image.width + posX) * 4;
        const r = dataWithAlpha[pos];
        const g = dataWithAlpha[pos + 1];
        const b = dataWithAlpha[pos + 2];

        if (steinform === _shopConfig.stoneSquareValue) {
          // drawStep3('landscape');

          const pyramid = ctx.createLinearGradient(
            x * size,
            (y + 1) * size,
            (x + 1) * size,
            y * size,
          );
          pyramid.addColorStop(
            0,
            `rgb(${(r * darker) / 100}, ${(g * darker) / 100}, ${(b * darker) / 100})`,
          );
          pyramid.addColorStop(0.5, `rgb(${r}, ${g}, ${b})`);
          pyramid.addColorStop(
            1,
            `rgb(${(r * lighter) / 100}, ${(g * lighter) / 100}, ${(b * lighter) / 100})`,
          );
          ctx.fillStyle = pyramid;
        } else {
          const cx = x * size + size / 2;
          const cy = y * size + size / 2;
          const dot = ctx.createRadialGradient(cx, cy, 0, cx, cy, size);
          dot.addColorStop(
            0,
            `rgb(${(r * lighter) / 100}, ${(g * lighter) / 100}, ${(b * lighter) / 100})`,
          );
          dot.addColorStop(0.5, `rgb(${r}, ${g}, ${b})`);
          dot.addColorStop(
            1,
            `rgb(${(r * darker) / 100}, ${(g * darker) / 100}, ${(b * darker) / 100})`,
          );
          ctx.fillStyle = dot;
        }

        ctx.fillRect(x * size, y * size, size, size);

        // if (steinform === 'Quadratisch') {
        //   const grd = ctx.createRadialGradient(posX+2, posY+2, 0.02, posX+2, posY+2, 4);
        //   // let grd = ctx.createLinearGradient(x * scaleFactor, (y + 1) * scaleFactor, (x + 1) * scaleFactor, y * scaleFactor);
        //   grd.addColorStop(0, `white`);
        //   grd.addColorStop(0.1, `rgb(${r}, ${g}, ${b})`);
        //   grd.addColorStop(1, `rgba(${r / darker }, ${g / darker}, ${b / darker},0.2)`);
        //   // grd.addColorStop(1, `rgba(${r / darker }, ${g / darker}, ${b / darker},0.5)`);
        //   // grd.addColorStop(0.5, `rgb(${r}, ${g}, ${b})`);
        //   // grd.addColorStop(0, `rgb(${r * lighter / 100}, ${g * lighter / 100}, ${b * lighter / 100})`);
        //   ctx.fillStyle = grd;
        //   ctx.fillRect(x * scaleFactor, y * scaleFactor, scaleFactor, scaleFactor);
        // } else {
        //   drawCircleWithGradient(ctx, x, y, r, g, b, scaleFactor, darker, lighter);
        // }
      }
    }

    // if( instance.appContext.config.globalProperties.$producttype.trim() == 'Eigenes Bild  XXL / 3') {
    //   drawStep3(instance.appContext.config.globalProperties.$orientation.value);
    // } else if(instance.appContext.config.globalProperties.$producttype.trim() == 'Eigenes Bild XXL / 5') {
    //   drawStep5(instance.appContext.config.globalProperties.$orientation.value, getDimensionsDataFromTitle('2x20x35-2x20x45-1x20x55'));
    // }
  };
});
</script>
<template>
  <div class="imgVorschau">
    <div class="canvasBox">
      <canvas id="canvas"></canvas>
    </div>
  </div>
  <!--  <a class="back" @click="$router.back()">Zurück</a>-->
  <div class="back">
    <RouterLink :to="productViewPath">{{ t("back") }}</RouterLink>
  </div>
</template>

<style>
.imgVorschau {
  display: flex;
  justify-content: center;
  align-items: center;
}
.back a {
  position: absolute;
  left: 40px;
  bottom: 4.1%;
  width: 160px;
  font-size: 18pt;
  background: #fff;
  color: #001761;
  padding: 3pt 10pt;
  display: inline-block;
  border-radius: 15px;
  outline: none;
  white-space: nowrap;
  -webkit-user-select: none;
  cursor: pointer;
  text-align: center;
  font-weight: 700;
}
.canvasBox {
  background: #d9d7d3;
}

canvas#canvas {
  /*opacity: 0.8; filter: contrast(0.8) brightness(1.2);*/
}
</style>
